import { useNavigate } from "react-router-dom";
import Button from "../../atoms/button";
import { useLogoChangeStore } from "../../../lib/store/useLogoChangeStore.tsx";

interface Props {
  next: () => void;
}

export default function SignScreen({ next }: Props) {
  const navigate = useNavigate();
  const { showPochenLogo } = useLogoChangeStore();

  return (
    <div className="flex flex-col justify-between min-h-screen px-[35px]">
      <div className="flex flex-col justify-center items-center text-center flex-1">
        <img className="w-[225px]" src="/images/img-login-logo.webp" />
        <p className="text-2xl font-bold pt-[13px]">처음이신가요?</p>
        <span className="text-xs text-[#888] font-[500] py-[24px]">
          파크골프가 쉬워지는 방법
        </span>
        {showPochenLogo ? (
          <img className="h-5" src="/icons/ic-pochen-ko-logo.webp" />
        ) : (
          <img className="h-5" src="/icons/ic-bi-logo.webp" />
        )}
      </div>
      <div className="space-y-[10px] pb-[35px]">
        <div
          className="flex-row justify-center gap-[10px] text-center w-full cursor-pointer"
          onClick={() => navigate("/", { replace: true })}
        >
          <p className="text-xs font-[500] text-[#888]">둘러보기</p>
          <img className="w-[5px] h-[9px]" src="/icons/ic-go.webp" />
        </div>
        <Button
          onClick={next}
          className="w-full font-bold text-sm"
          variant={"white"}
          label="기존 회원"
        />
        <Button
          onClick={() => navigate("/signup")}
          className="w-full font-bold text-sm"
          variant={"primary"}
          label="처음 가입하기"
        />
      </div>
    </div>
  );
}
